import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { environment } from './environments/environment';
import { loadRuntimeConfig } from './environments/runtime-config';

// ⚠️ AppModule is reached through a DYNAMIC import() below and is deliberately NOT
// imported at the top of this file (INTO-324). Its decorator metadata reads
// environment.AUTH0_*, environment.BASE_API_URL and environment.i18nBaseUrl while
// the module is evaluated, and a static import is hoisted above every statement
// here -- so it would capture the compiled values before loadRuntimeConfig() could
// overlay config.json. Making this a static import again would silently reinstate
// the baked-in URLs. See ./environments/runtime-config.ts.
loadRuntimeConfig()
  .then(async () => {
    if (environment.production) {
      enableProdMode();
    }

    const { AppModule } = await import('./app/app.module');

    return platformBrowser().bootstrapModule(AppModule, {
      applicationProviders: [provideZoneChangeDetection()],
    });
  })
  .catch((err) => console.error(err));
